'use client'

import { createContextWithProvider } from '@qr-front/ui/utils/context'
import {
	ColumnFiltersState,
	RowSelectionState,
	SortingState,
} from '@tanstack/react-table'
import { atom } from 'jotai'

import { TQrData } from '@/generator/shared'

import { TRow, TTable } from './tableTypes'

export const qrListAtom = atom<TQrData[]>([])

export const isScansDataStaleAtom = atom(true)

export const tableAtom = atom(undefined as unknown as TTable)

export const tableSelectionAtom = atom<RowSelectionState>({})

export const tableColumnFiltersAtom = atom<ColumnFiltersState>([])

export const tableSortingAtom = atom<SortingState>([])

export const duplicatedQrHighlightAtom = atom<string | null>(null)

export const [rowContext, RowProvider] = createContextWithProvider<TRow>('row')
